import { render, staticRenderFns } from "./message_receive_user.vue?vue&type=template&id=f3de81d2&scoped=true&"
import script from "./message_receive_user.vue?vue&type=script&lang=ts&"
export * from "./message_receive_user.vue?vue&type=script&lang=ts&"
import style0 from "./message_receive_user.vue?vue&type=style&index=0&id=f3de81d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3de81d2",
  null
  
)

export default component.exports